import React, { useContext, useEffect } from 'react'
import { GlobalUserContext, GlobalUserContextPayload } from '../../Context/GlobalUserDetailContext';

const UserbackWidget = () => {

    const { userProfileDetails } = useContext(GlobalUserContext) as GlobalUserContextPayload

    useEffect(() => {
        if (userProfileDetails.flagLoggedIn == null) {
            return
        }
        // check existing userback destroy existing userback and remove old script.
        const existingScript = document.getElementById('userback-widget')
        if ((window as any).Userback && typeof (window as any).Userback.destroy === 'function') {
            (window as any).Userback.destroy()
        }
        if (existingScript) {
            existingScript.remove()
        }

        (window as any).Userback = {};
        (window as any).Userback.access_token = "P-y27XF6wyGFrYmqmXH0FUvhvQK";

        if (userProfileDetails.flagLoggedIn) {
            (window as any).Userback.user_data = {
                id: "123456",
                info: {
                    name: "someone",
                    email: "someone@example.com"
                }
            };
        }

        const s = document.createElement('script');
        s.id = 'userback-widget';
        s.async = true;
        s.src = 'https://static.userback.io/widget/v1.js';
        document.head.appendChild(s);
    }, [userProfileDetails.flagLoggedIn])

    return null
}

export default UserbackWidget
